import { sprintf } from 'sprintf-js';
import { DeviceDataOverrideService } from '../services';

class ReportDataHelper {
    static applyDataTypeConverterAndFormat(value, dataTypeConverterToken, deviceDataDisplayTypeFormat) {
        var response = value;
        const converter = DeviceDataOverrideService.getOverrideForDisplayToken(dataTypeConverterToken);
        const format = DeviceDataOverrideService.getOverrideForDisplayFormat(deviceDataDisplayTypeFormat);

        switch (converter) {
            case "c_to_f": {
                response = parseFloat(value) * (9 / 5) + 32;
            } break;
            case "bool_to_open_closed": {
                response = value ? (value === true ? "Open" : "Closed") : "Unknown";
            } break;
            case "bool_to_online_offline": {
                response = value ? (value === true ? "Online" : "Offline") : "Unknown";
            } break;
        }
        return format != null ? sprintf(format, response) : response;
    }

    static convertQueryResponse(queryResponseData) {
        return queryResponseData.map((responseEntry) => {
                return Object.entries(responseEntry)
                             .reduce((reo, [key, value]) => {
                                 reo[key.toLowerCase().replace(/[-_][a-z]/g, (group) => group.slice(-1).toUpperCase())] = value;
                                 return reo;
                             }, {});
            });
    }

    static convertSortRequestValues(sorts) {
        return sorts.map((sortValueEntry) => {
            var sortValue = Object.assign({}, sortValueEntry);
            sortValue.id = sortValue.id.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            return sortValue;
        });
    }
}

export default ReportDataHelper;